import {alpha} from "@mui/material/styles";

const primaryMainDark = "#ffffff";
const primaryMainLight = "#000000";

const dividerColorDark = "#E5DAE5";
const secondaryMainDark = "#E11D5C";
const secondaryMainLight = "#E11D5C";

export const secondary = {
  // main: secondaryMain,
};
export const info = {
  main: "#10051C",
};
export const success = {
  main: "#03c595",
};
export const warning = {
  main: "#FA9013",
};
export const error = {
  main: "#FF4B4B",
};

const textPrimaryColorLight = "#10051C";
export const textLight = {
  primary: textPrimaryColorLight,
  secondary: alpha(textPrimaryColorLight, 0.6),
  tertiary: alpha(textPrimaryColorLight, 0.4),
};

const textPrimaryColorDark = "#FFFFFF";
export const textDark = {
  primary: textPrimaryColorDark,
  secondary: alpha(textPrimaryColorDark, 0.6),
  tertiary: alpha(textPrimaryColorDark, 0.4),
};

export const backgroundLight = {
  default: "#ffffff",
  paper: "#F3F5F9",
  card: "#F8F9FB",
  avatar: "#0D0E0E",
  popup: "#ffffff",

  success: "rgba(3, 197, 139, .1)",
  error: "rgba(255, 75, 75, .1)",
  warning: "rgba(250, 144, 19, .1)",
};
export const backgroundDark = {
  default: "#0D0E0E",
  // default: "#222324",
  paper: "#252727",
  card: "#222324",
  avatar: "#ffffff",
  popup: "#252727"
};

const palette = {
  // info,
  error,
  // primary,
  success,
  warning,
  // secondary,
};

const brandColor = {
  main: "#e11d5c",
};

const cardgradientColorLight = {
  red: "linear-gradient(247deg, #E41B38 12.36%, #E21E5F 75.56%)",
  black: "linear-gradient(310deg, #FFCB67 0.71%, #ED5409 31.12%, #506179 62.69%, #214E81 82.38%, #102D3C 98.11%), radial-gradient(101.05% 128.77% at -3.11% -1.41%, rgba(255, 255, 255, 0.30) 0%, rgba(255, 255, 255, 0.00) 100%), rgba(7, 7, 7, 0.70)",
};
const cardgradientColorDark = {
  red: "linear-gradient(247deg, #E41B38 12.36%, #E21E5F 75.56%)",
  black: "linear-gradient(310deg, #FFCB67 0.71%, #ED5409 31.12%, #506179 62.69%, #214E81 82.38%, #102D3C 98.11%), radial-gradient(101.05% 128.77% at -3.11% -1.41%, rgba(255, 255, 255, 0.30) 0%, rgba(255, 255, 255, 0.00) 100%), rgba(7, 7, 7, 0.70)",
};

export const lightPalette = {
  mode: "light",
  ...palette,
  primary: {
    main: primaryMainLight,
  },
  text: textLight,
  borderColor: {
    divider: alpha("#10051C", 0.05),
  },
  brand: brandColor,
  background: backgroundLight,
  card: cardgradientColorLight,
};

export const darkPalette = {
  mode: "dark",
  ...palette,
  primary: {
    main: primaryMainDark,
  },
  text: textDark,
  borderColor: {
    divider: alpha("#10051C", 0.05),
  },
  brand: brandColor,
  background: backgroundDark,
  card: cardgradientColorDark,
};
